document.addEventListener("DOMContentLoaded", () => {
  const accordionGroups = document.querySelectorAll("[data-accordion-group]");

  const collapseContent = (content) => {
    if (!content) return;

    if (content.style.height === "auto" || content.offsetHeight > 0) {
      content.style.height = `${content.scrollHeight}px`;
      // force reflow so the browser acknowledges the current height
      void content.offsetHeight;
    }

    requestAnimationFrame(() => {
      content.style.height = "0px";
    });
  };

  const expandContent = (content) => {
    if (!content) return;

    const setAutoHeight = () => {
      content.style.height = "auto";
      content.removeEventListener("transitionend", setAutoHeight);
    };

    content.addEventListener("transitionend", setAutoHeight);
    content.style.height = `${content.scrollHeight}px`;
  };

  const initializeGroup = (group) => {
    const items = group.querySelectorAll(".ab-accordion-item");

    items.forEach((item) => {
      const trigger = item.querySelector("[data-accordion-trigger]");
      const content = item.querySelector("[data-accordion-content]");

      if (!trigger || !content) return;

      // Initialize based on ab-active class
      if (item.classList.contains("ab-active")) {
        content.style.height = "auto";
      } else {
        content.style.height = "0px";
      }

      trigger.addEventListener("click", () => {
        const isActive = item.classList.contains("ab-active");

        items.forEach((other) => {
          if (other === item) return;
          other.classList.remove("ab-active");
          collapseContent(other.querySelector("[data-accordion-content]"));
        });

        if (isActive) {
          item.classList.remove("ab-active");
          collapseContent(content);
        } else {
          item.classList.add("ab-active");
          expandContent(content);
        }
      });
    });
  };

  accordionGroups.forEach(initializeGroup);
});
